import React, { useEffect, useState, Fragment, useRef } from "react";
import { WeighPointWiseDeductionReportTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const contentRowName = this.props.rowNames;
        const reportData = this.props.reportData;

        return (
            <div>
                <h3 className="pr-2"><center><u>Weigh Point Wise Deduction Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Esate: </b> {searchData.estate}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table id="blockWeighment" className="display dataTable no-footer">
                        <thead>
                            <tr>
                                {contentRowName.map((x, index) => {
                                    let result = x.replace(/([A-Z])/g, " $1");
                                    let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                                    return (
                                        <th key={index}>{finalResult}</th>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            <WeighPointWiseDeductionReportTableContent
                                data={reportData}
                                contentRowNames={contentRowName}
                                hasEdit={false}
                            />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}